import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { Button } from '../Button/index.js';
import { DisplayWidthForCards } from '../Layout/Display/DisplayWidthForCards.js';
import { i18n } from '../../i18n/translate.js';
import { Stack } from '@chakra-ui/react';
import { ConstructionCard } from '../ConstructionCard/component.js';
import { ExplainerText } from '../ExplainerText/component.js';
import { FAIcon } from '../fa-icon/component.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
import { format } from '../../utils/dateHelpers.js';

var WizardCards = function WizardCards(props) {
  var _props$saveBtnLabel = props.saveBtnLabel,
      saveBtnLabel = _props$saveBtnLabel === void 0 ? i18n.t('Save') : _props$saveBtnLabel,
      _props$stepCardProps = props.stepCardProps,
      stepCardProps = _props$stepCardProps === void 0 ? {} : _props$stepCardProps,
      _props$steps = props.steps,
      steps = _props$steps === void 0 ? [] : _props$steps,
      taskCardProps = props.taskCardProps,
      _props$initialStep = props.initialStep,
      initialStep = _props$initialStep === void 0 ? 0 : _props$initialStep;

  var _useState = useState(initialStep),
      _useState2 = _slicedToArray(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var allTasksCompleted = steps.every(function (step) {
    return step.tasks && step.tasks.every(function (task) {
      return task.completed_at;
    });
  });

  var isFirstStep = function isFirstStep(position) {
    return position === 0;
  };

  var isLastStep = function isLastStep(position) {
    return position === steps.length - 1;
  };

  var handleCompleteTask = function handleCompleteTask(task) {
    if (task.onComplete) task.onComplete();

    if (props.onCompleteTask) {
      props.onCompleteTask(task);
    }
  };

  var undoTask = function undoTask(task) {
    if (props.onUndoTask) {
      props.onUndoTask(task);
    }
  };

  var getStepContent = function getStepContent(step) {
    if (!step.tasks) {
      return step.content;
    }

    return step.tasks.map(function (task) {
      return /*#__PURE__*/React.createElement(ConstructionCard, _extends({}, taskCardProps, {
        key: task.title,
        title: task.title,
        expanded: true,
        className: _formatClassName(['wizard-task-card', props.stepClassName]),
        attentionGrabber: task.completed_at ? {
          label: i18n.t('Complete'),
          type: 'success'
        } : null
      }), /*#__PURE__*/React.createElement(ExplainerText, null, task.description, !!task.learnMoreUrl && /*#__PURE__*/React.createElement("a", {
        href: task.learnMoreUrl,
        className: "m-l-5",
        target: "_blank",
        rel: "noopener noreferrer"
      }, i18n.t('Learn More'))), task.completed_at && /*#__PURE__*/React.createElement("div", {
        className: "task-complete-info"
      }, /*#__PURE__*/React.createElement(FAIcon, {
        icon: "check",
        additionalClasses: "m-r-5"
      }), i18n.t('Marked Complete by %s on %s', {
        postProcess: 'sprintf',
        sprintf: [task.user, format(task.completed_at, 'PPP')]
      }), /*#__PURE__*/React.createElement(Button, {
        style: "link",
        icon: "undo",
        onClick: function onClick() {
          return undoTask(task);
        },
        label: i18n.t('Undo'),
        className: "m-l-10"
      })), /*#__PURE__*/React.createElement("div", {
        className: "task-buttons"
      }, /*#__PURE__*/React.createElement(Button, {
        style: "secondary",
        href: task.goToUrl,
        label: task.goToLabel,
        className: "btn-goto-task"
      }), !task.completed_at && /*#__PURE__*/React.createElement(Button, {
        style: "secondary",
        onClick: function onClick() {
          return handleCompleteTask(task);
        },
        icon: "check",
        label: i18n.t('Mark Task Complete'),
        className: "btn-complete-task"
      })));
    });
  };

  var getStepNavButtons = function getStepNavButtons(position) {
    return /*#__PURE__*/React.createElement("div", {
      className: "wizard-nav-buttons"
    }, !isFirstStep(position) && /*#__PURE__*/React.createElement(Button, {
      style: "link",
      label: i18n.t('Previous Step'),
      icon: "arrow-left",
      className: "btn-previous",
      onClick: function onClick() {
        return navigateStep('backwards', position);
      }
    }), !isLastStep(position) && /*#__PURE__*/React.createElement(Button, {
      label: i18n.t('Next Step'),
      rightIcon: "arrow-right",
      className: "btn-next",
      onClick: function onClick() {
        return navigateStep('forward', position);
      }
    }));
  };

  var navigateStep = function navigateStep(direction, position) {
    // since steps can be expanded when out of focus, we need to set boundaries for movement
    var index = activeStep !== position ? position : activeStep;
    var noAction = isFirstStep(index) && direction === 'backwards' || isLastStep(index) && direction === 'forward';
    var movement = noAction ? 0 : 1;
    var newStep = direction === 'backwards' ? index - movement : index + movement;
    setActiveStep(newStep);
  };

  var _onExpandedToggle = function onExpandedToggle(index, expanded) {
    if (expanded) {
      setActiveStep(index);
    }
  };

  return /*#__PURE__*/React.createElement("div", _extends({}, pickDataAttributes(props), {
    className: _formatClassName(['wizard-cards', props.className])
  }), /*#__PURE__*/React.createElement(DisplayWidthForCards, null, /*#__PURE__*/React.createElement(Stack, null, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(ConstructionCard, _extends({}, stepCardProps, {
      key: index,
      className: _formatClassName(['wizard-step-card', props.stepClassName]),
      title: step.title,
      onExpandedToggle: function onExpandedToggle(expanded) {
        return _onExpandedToggle(index, expanded);
      },
      expanded: activeStep === index,
      headerImageUrl: step.imageUrl
    }), /*#__PURE__*/React.createElement(ExplainerText, null, step.description), /*#__PURE__*/React.createElement(Stack, null, getStepContent(step)), getStepNavButtons(index));
  })), /*#__PURE__*/React.createElement("div", {
    className: _formatClassName(['wizard-cards-actions', stepCardProps.size])
  }, /*#__PURE__*/React.createElement(Button, {
    label: saveBtnLabel,
    onClick: props.onFinish,
    className: "btn-finish",
    disabled: !allTasksCompleted
  }))));
};

WizardCards.displayName = "WizardCards";
export { WizardCards };